import type { ScheduledPost } from "../../types.js";

/**
 * Shared constants + the adjustability predicate for the schedule calendar,
 * extracted from `ScheduleCalendar.tsx` so `isAdjustable` unit-tests directly.
 */
export const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] as const;

/** How many "HH:mm · Platform" chips a day cell shows before it collapses to "+N more". */
export const CHIPS_PER_CELL = 2;

/** A scheduled post can still be moved/cancelled while it hasn't shipped. */
export function isAdjustable(p: ScheduledPost): boolean {
  return p.status === "queued" || p.status === "safe_mode";
}
